import { render, staticRenderFns } from "./saveDingGroupDialog.vue?vue&type=template&id=80fb0518&scoped=true&"
import script from "./saveDingGroupDialog.vue?vue&type=script&lang=js&"
export * from "./saveDingGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./saveDingGroupDialog.vue?vue&type=style&index=0&id=80fb0518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fb0518",
  null
  
)

export default component.exports